import Client from 'Api/Client';
import EndPoint from 'Api/EndPoint';

const endpoint = `${EndPoint.Host}/${EndPoint.Auth}`;

export async function joinFromTeamRecruitment(data) {
  return await Client.post(`${endpoint}/joinFromTeamRecruitment`, data, false);
}

export async function login(data) {
  return await Client.post(`${endpoint}/login`, data, false);
}

export async function me() {
  return await Client.get(`${endpoint}/user`, {}, true);
}

export async function tokenRefresh() {
  return await Client.post(`${endpoint}/token/refresh`, {}, true);
}

// 로그아웃
export async function postLogout() {
  return await Client.post('https://nayaapis.com/api/user/logout', {}, true);
}
// 비밀번호 변경
export async function postPassword(data) {
  return await Client.post('https://nayaapis.com/api/material/auth/password', data, true);
}

// 프로필 이미지 업로드
export async function uploadFileProfileImage(image, onProgress = null) {
  return await Client.uploadFile(`${endpoint}/user/profileImage/upload`, 'image', image, onProgress);
}

// 프로필 이미지
export async function patchProfileImage(data) {
  return await Client.patch(`${endpoint}/user/profileImage`, data, true);
}

// 인증없는 파일 업로드
export async function uploadFileWithoutAuth(image, onProgress = null) {
  return await Client.uploadFileWithoutAuth(`${endpoint}/uploadFile`, 'image', image, onProgress);
}
